module.exports = __webpack_public_path__ + "static/itunes-308d06de35d7734b68a69160578b9058.png";